export const SELECT_ALL_VALUE = 'select-all';
export const CREATE_NEW_VALUE = 'create-new';
